import Head from 'next/head';

import SignUpScreen from 'screens/auth/SignUp';

import { HUBSPOT_URL } from 'utils/settings';
import StoreThemeProvider from 'styles/theme/provider';

const SignUp = () => (
  <StoreThemeProvider>
    <Head>
      <script type="text/javascript" id="hs-script-loader" async defer src={HUBSPOT_URL} />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
      />
      <title>Cadastro - TC</title>
    </Head>
    <SignUpScreen />
  </StoreThemeProvider>
);

export default SignUp;
